import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { getContentBlockItemValue } from '../../../CmsActions.js';
import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';

function PanelExitIntent({ panel }) {
    const promo1 = getContentBlockItemValue(panel.blocks, 'promo1');
    const promo2 = getContentBlockItemValue(panel.blocks, 'promo2');
    const extra = getContentBlockItemValue(panel.blocks, 'extra');
    return (
        <div>
            <Row className="g-2 mb-3">
                <Col xs="12" md="5">
                    <div className="bg-white border rounded p-3 h-100 text-center">
                        <HtmlComponent text={promo1} />
                    </div>
                </Col>
                <Col xs="12" md="2" className="d-flex align-items-center justify-content-center">
                    <span className="text-secondary fw-bold">OU</span>
                </Col>
                <Col xs="12" md="5">
                    <div className="bg-white border rounded p-3 h-100 text-center">
                        <HtmlComponent text={promo2} />
                    </div>
                </Col>
            </Row>
            <HtmlComponent text={extra} />
        </div>
    );
}

PanelExitIntent.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelExitIntent;
